export default "__VITE_ASSET__Bgi2m_xP__"